module.exports = __webpack_public_path__ + "media/images/heroes/home-2-9cf15eed99a220ba44434cadc36ee5b5.png";